import React from 'react';
import HeroCarouselMain from '../hero-carousel/HeroCarouselMain';

const HeroCarousel = ({ module }) => {
  return <HeroCarouselMain fields={module.fields} />;
};

export default HeroCarousel;
